import { render, staticRenderFns } from "./ProductCardMobile.vue?vue&type=template&id=420d47bb&scoped=true"
import script from "./ProductCardMobile.vue?vue&type=script&lang=js"
export * from "./ProductCardMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductCardMobile.vue?vue&type=style&index=0&id=420d47bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d47bb",
  null
  
)

export default component.exports